import { getModelConfig } from './model-config';

export function optimizePrompt(userPrompt: string, modelId: string): string {
    const config = getModelConfig(modelId);
    if (!config?.optimization) return userPrompt;

    let optimized = userPrompt;

    if (config.optimization.prefix) {
        optimized = `${config.optimization.prefix}${optimized}`;
    }

    if (config.optimization.suffix) {
        optimized = `${optimized}${config.optimization.suffix}`;
    }

    return optimized;
}

export function getNegativePrompt(userNegativePrompt: string | undefined, modelId: string): string {
    const config = getModelConfig(modelId);
    const defaultNegative = config?.optimization?.negativePrompt || "low quality, ugly, distorted, artefacts, amateur, watermark, text";

    if (userNegativePrompt) {
        return `${defaultNegative}, ${userNegativePrompt}`;
    }

    return defaultNegative;
}
